const actions = {
    FETCH_MONTH_DECLARATIONS: 'FETCH_MONTH_DECLARATIONS',
    FETCH_MONTH_DECLARATION: 'FETCH_MONTH_DECLARATION',
    RESET_MONTH_DECLARATION: 'RESET_MONTH_DECLARATION',

    fetchMonthDeclarationsAction: (data) => {
        return {
            type: actions.FETCH_MONTH_DECLARATIONS,
            data: data
        };
    },
    resetMonthDeclarationFormAction: () => {
        return {
            type: actions.RESET_MONTH_DECLARATION,
            data: null
        };
    },
    fetchMonthDeclarationAction: (data) => {
        return {
            type: actions.FETCH_MONTH_DECLARATION,
            data: data
        };
    },
};

export default actions;

